<app-topbar></app-topbar>
<app-sidebar></app-sidebar>

<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row">
      <div class="content-header-left col-md-6 col-12 mb-2">
        <h3 class="content-header-title mb-0">Webhook</h3>
        <div class="row breadcrumbs-top">
          <div class="breadcrumb-wrapper col-12">
            <ol class="breadcrumb">
              Configure webhook notifications for your account
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="content-body">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Webhook Configuration</h4>
            </div>
            <div class="card-body">
              <form [formGroup]="form" (ngSubmit)="updateAdmin()">
                <div class="row">
                  <div class="col-md-2"></div>
                  <div class="col-md-8">
                    <div class="row mb-3">
                      <div class="col-md-5 heading">WebHook URL</div>
                      @if (edit.isEdit === false) {
                        <div class="col-md-7 detail">{{data?.webhook || 'Not Specified'}}</div>
                      }
                      @if (edit.isEdit === true) {
                        <div class="col-md-7 detail">
                          <input type="text" formControlName="webhook" class="form-control" name="webhook" placeholder="Your Webhook URL e.g https://www.customurl.com/post"/>
                          @if (webhook.invalid && webhook.touched) {
                            <div class="alert alert-danger error mt-2 mb-0">
                              @if (webhook.errors.required) {
                                <div>Webhook URL is required</div>
                              }
                              @if (webhook.errors.minlength) {
                                <div>Please complete the address</div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>

                    <div class="row mb-3">
                      <div class="col-md-5 heading">Secret Hash</div>
                      @if (edit.isEdit === false) {
                        <div class="col-md-7 detail">
                          @if (data?.webhook !== '') {
                            <span class="text-bold-600">{{data?.hash_verification }}******</span>
                          }
                          @if (data?.webhook === '') {
                            <span>{{'Not Specified'}}</span>
                          }
                        </div>
                      }
                      @if (edit.isEdit === true) {
                        <div class="col-md-7 detail">
                          <div class="input-group">
                            <input [type]="passwordType" formControlName="hash_verification" class="form-control" name="hash_verification" placeholder="Your New Secret Hash"/>
                            <div class="input-group-append">
                              <button type="button" class="input-group-text" (click)="togglePassword()" aria-label="Toggle password visibility">
                                <i class="fa fa-eye-slash" [(class)]="icon"></i>
                              </button>
                            </div>
                          </div>
                          @if (hash_verification.invalid && hash_verification.touched) {
                            <div class="alert alert-danger error mt-2 mb-0">
                              @if (hash_verification.errors.required) {
                                <div>Secret Hash is required</div>
                              }
                              @if (hash_verification.errors.minlength) {
                                <div>Minimum required length is 6 characters</div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-md-2"></div>

                  <div class="col-12 text-center">
                    @if (edit.isEdit === false) {
                      <button class="btn btn-success" (click)="onClick()"><span>{{ option }}</span> WEBHOOK</button>
                    }
                    @if (edit.isEdit === true) {
                      <button class="btn btn-success" type="submit" [disabled]="form.invalid || clicked === true">SAVE CHANGES</button>
                    }
                    @if (clicked === true) {
                      <i class="icons icon-loading"></i>
                    }
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-bottombar></app-bottombar>
